import { CouponType, OrderMethod, PaymentMethod, RefundReason } from '../../../../../../services/exports/Constants';

export default {
  title: 'Informacje o zamówieniu',
  sections: {
    driver_info: 'Informacje o kierowcy',
    order_info: 'Informacje o zamówieniu',
    price_info: 'Informacje o cenie',
    adjustments: 'Korekty',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Odbiór',
    [OrderMethod.Delivery]: 'Dostawa',
    [OrderMethod.OnSite]: 'Zamówienie do stolika',
  },
  labels: {
    wolt_support: 'Telefon wsparcia Wolt: {{phone_number}}',
    wolt_support_text:
      'Jeśli masz pytania o zamówienie, kierowcę lub problemy, zadzwoń do Wolt. Ważne, aby powiedzieć, że to zamówienie <strong>Wolt Drive</strong>',
    dummy_order: 'Zamówienie testowe',
    asap: 'ASAP',
    driver_name: 'Imię kierowcy',
    driver_phone_number: 'Telefon kierowcy',
    pin_code: 'PIN',
    dropoff_pin_code: 'PIN dostawy',
    original: 'Oryginał',
    delivery_fee: 'Opłata za dostawę',
    tip: 'Napiwek',
    service_fee: 'Obsługa online',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Opłata PayPal',
    },
    promo_applied: {
      default: 'Zastosowano promocję',
      [CouponType.Reward]: 'Zastosowano punkty lojalnościowe',
      [CouponType.Cashback]: 'Zastosowano punkty lojalnościowe',
      [CouponType.PromoCode]: 'Zastosowano promocję',
      [CouponType.GiftCard]: 'Zastosowano kartę podarunkową',
    },
    tax: 'Podatki',
    total: 'Suma',
    online_payment: 'Klient już zapłacił w aplikacji {{provider}}',
    cash_payment: 'Płatność na miejscu',
    invoice_payment: 'Płatność przez fakturę',
    old_order: 'To zamówienie zostało pomyślnie zrealizowane',
    pickup_time: 'Czas odbioru',
    pickup_asap: 'Klient poprosił o jak najszybszy odbiór.',
    points_used: 'Zamówienie zawiera nagrodę z punktów lojalnościowych stałego klienta',
    order_note: 'Uwaga do zamówienia:',
    today: 'dzisiaj',
  },
  schedule: {
    header: 'Zaplanowane na {{date}}, {{time}}',
    text: 'Przypomnimy Ci, gdy nadejdzie czas na przygotowanie zamówienia',
  },
  adjustment_reasons: {
    [RefundReason.RequestedByCustomer]: 'Na żądanie klienta',
    [RefundReason.Reclamation]: 'Reklamacja',
    [RefundReason.CommunicationError]: 'Błąd komunikacji',
    [RefundReason.Other]: 'Inne',
    [RefundReason.Dispute]: 'Spór z klientem',
    dispute_win: 'Wygrany spór z klientem',
    null: '',
  },
  toasts: {
    print_one: 'Drukowanie {{count}} paragonu: Zamówienie <strong>#{{orderNumber}}</strong>...',
    print_few: 'Drukowanie {{count}} paragonów: zamówienie <strong>#{{orderNumber}}</strong>...',
    print_many: 'Drukowanie {{count}} paragonów: zamówienie <strong>#{{orderNumber}}</strong>...',
    print_other: 'Drukowanie {{count}} paragonów: Zamówienie <strong>#{{orderNumber}}</strong>...',
    refund_successful: 'Zwrot udany: Zamówienie <strong>#{{orderNumber}}</strong>...',
  },
  buttons: {
    print: 'Drukuj',
    confirm: 'Potwierdź',
    reject: 'Odrzuć',
    refund: 'Zwrot',
  },
};
